var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-snackbar',{attrs:{"top":""},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.message)}})])}
var staticRenderFns = []

export { render, staticRenderFns }